"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var ProductOptions = /** @class */ (function (_super) {
    __extends(ProductOptions, _super);
    function ProductOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.getOptionString = function (option, index) {
            var _a;
            var optionArray = [];
            var optionObject = __assign(__assign({}, _this.props.selectedOptions), (_a = {}, _a["option" + index] = option, _a));
            for (var _i = 0, _b = Object.entries(optionObject); _i < _b.length; _i++) {
                var _c = _b[_i], key = _c[0], value = _c[1];
                value !== null ? optionArray.push(value) : null;
            }
            var optionString = optionArray.join(" / ");
            return optionString;
        };
        _this.checkOnSale = function (optionString) { return _this.props.onSaleOptions.includes(optionString); };
        _this.checkDisabled = function (optionString) { return !_this.props.enabledOptions.includes(optionString); };
        _this.buildTitles = function (items, index) {
            return items.values
                ? items.values.map(function (item, i) { return (React.createElement("option", { key: i, value: item }, item)); })
                : [];
        };
        _this.buildList = function (items, index) {
            return items.values
                ? items.values.map(function (item, i) { return (React.createElement("option", { key: i, value: item }, item)); })
                : [];
        };
        _this.buildGrid = function (items, index) {
            return items.values
                ? items.values.map(function (item, i) {
                    var isOnSale = _this.checkOnSale(_this.getOptionString(item, index));
                    var isDisabled = _this.checkDisabled(_this.getOptionString(item, index));
                    console.log('item:', item);
                    return (React.createElement("li", { key: i, className: "mr-0-7 mb-0-8 block relative overflow-hidden" },
                        React.createElement("button", { type: "button", title: item, onClick: function (event) { return _this.props.onChange(item, index); }, className: "relative flex items-center justify-center border border-transparent rounded w-6-1 h-4 sm:w-6-3 sm:h-6-3 transition-fast outline-none focus:outline-none text-md " + (isDisabled
                                ? "text-secondary-blue-grey border-secondary-blue-grey font-normal"
                                : _this.props.selected && _this.props.selectedOptions["option" + index] === item
                                    ? "text-arctic bg-navy border-transparent font-bold"
                                    : "text-navy-dark bg-arctic border-transparent hover:border-navy-dark font-medium") },
                            item,
                            React.createElement("div", { className: "hidden sm:block absolute pin-b pb-0-4 font-semibold text-xs" }, isDisabled ? (React.createElement("span", { className: "text-secondary-blue-grey" }, "sold out")) : isOnSale ? (_this.props.selected && _this.props.selectedOptions["option" + index] === item ? null : (React.createElement("span", { className: "text-red" }, "Sale"))) : null))));
                })
                : [];
        };
        _this.buildSwatch = function (items, config, index) {
            return items.values
                ? items.values.map(function (item, i) { return (React.createElement("li", { key: i, className: "font-normal inline-block pb-2" },
                    React.createElement("button", { type: "button", value: items.name, title: item, className: "\n                  border-2\n                  " + (_this.props.selected && _this.props.selectedOptions["option" + index] === item
                            ? "border-midnight"
                            : "border-arctic hover:border-grey-light") + "\n                  inline-block outline-none focus:outline-none border-4 w-4 h-4 p-4 mr-3 text-center text-midnight no-underline rounded-full cursor-pointer", onClick: function (event) { return _this.props.onChange(event.target, index); }, style: _this.getSwatchImage(item, config) }))); })
                : [];
        };
        return _this;
    }
    ProductOptions.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, options = _a.options, selected = _a.selected, selectedOptions = _a.selectedOptions, showTitles = _a.showTitles, isPreorder = _a.isPreorder, variant = _a.variant;
        return options
            ? options.map(function (option, i) {
                var optionHandle = option.name.toLowerCase();
                var config = _this.props.config[optionHandle];
                var isDisabled = _this.checkDisabled(_this.getOptionString(selectedOptions["option" + (i + 1)], i + 1));
                return config && option.values[0] !== "-" && option.values[0] !== "." ? (React.createElement("div", { key: i, className: "" + _this.props.className },
                    showTitles && optionHandle !== "title" && config.title != false ? (React.createElement("div", { className: "text-xs font-medium mb-1-7 flex flex-row justify-between" },
                        React.createElement("div", null,
                            React.createElement("span", { className: "inline-block align-middle text-charcoal" },
                                "Select\u00A0",
                                option.name,
                                selected ? ":" : null),
                            React.createElement("span", { className: "inline-block align-middle text-midnight ml-0-4 font-bold" }, selected ? isDisabled ? React.createElement("span", { className: "text-red" }, "Sold Out") : selectedOptions["option" + (i + 1)] : null)),
                        !variant.available && selected && !isPreorder && config.stock ? (React.createElement("span", { className: "inline-block align-middle ml-0-4 text-highlight font-normal" }, data.locales.global.cart.sold_out_online)) : variant.available && selected && config.stock ? (React.createElement("span", { className: "inline-block align-middle ml-0-4 text-charcoal" },
                            data.locales.global.cart.available,
                            " ",
                            data.locales.product.shipping)) : null,
                        config.linkText && (config.click || config.link) && (React.createElement("div", { className: "text-right block" },
                            React.createElement(Snippets.Link, { colour: "midnight", size: "inherit", onClick: config.click ? config.click : null, href: config.link ? config.link : null, className: "text-xs capitalize cursor-pointer tracking-wider underline transition-fast gtm:size-guide-open" }, config.linkText))))) : null,
                    config.layout === "list" ? (React.createElement("div", { className: "relative" },
                        React.createElement("div", { className: "absolute pin flex items-center justify-between pointer-events-none px-1-2 text-charcoal" },
                            React.createElement("p", { className: "text-sm font-medium" }, option.name),
                            React.createElement(Snippets.Svg, { name: "chevron-down", width: 16, className: "block" })),
                        React.createElement("select", { defaultValue: selectedOptions["option" + (i + 1)], className: "block appearance-none px-3-2 py-1-1 cursor-pointer border border-grey-mid bg-transparent rounded-none w-full max-w-full focus:outline-none text-sm font-medium text-midnight text-last-right", onChange: function (e) { return _this.props.onChange(e.target.value, i + 1); } }, _this.buildList(option, i + 1)))) : null,
                    config.layout === "grid" ? React.createElement("ul", { className: "list-reset flex flex-wrap" }, _this.buildGrid(option, i + 1)) : null,
                    config.layout === "swatch" ? (React.createElement("ul", { className: "list-reset flex flex-wrap whitespace-no-wrap md:whitespace-normal overflow-x-auto md:overflow-visible" }, _this.buildSwatch(option, config, i + 1))) : null)) : null;
            })
            : null;
    };
    ProductOptions.prototype.getSwatchImage = function (item, config) {
        var color = config.colorMap && config.colorMap[item] ? config.colorMap[item] : item;
        return {
            backgroundColor: "" + color,
            backgroundSize: this.props.swatches && this.props.swatches[next_components_1.ShopifyNext.Utils.slugify(item)] ? "contain" : null,
            backgroundImage: this.props.swatches && this.props.swatches[next_components_1.ShopifyNext.Utils.slugify(item)]
                ? "url(" + this.props.swatches[next_components_1.ShopifyNext.Utils.slugify(item)] + ")"
                : null
        };
    };
    ProductOptions.contextType = next_components_1.ShopifyNext.Context;
    return ProductOptions;
}(React.PureComponent));
exports.ProductOptions = ProductOptions;
